import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'combo-raca',
  templateUrl: './combo-raca.component.html',
  styleUrls: ['./combo-raca.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm },
                  { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }],
})
export class ComboRacaComponent implements OnInit {

  @ViewChild('comboRaca', {static: false}) comboRaca;

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;

  @Output() valorChange = new EventEmitter();

  dados = [];
  data: any = {};

  constructor() {
  }

  ngOnInit(): void {
    this.data = Date.now();

    // Dados estáticos das raças
    this.dados = [
      { id: 1, tipo: 'Amarelo' },
      { id: 2, tipo: 'Branco' },
      { id: 3, tipo: 'Indígena' },
      { id: 4, tipo: 'Negro' },
      { id: 5, tipo: 'Pardo' }
    ];

    this.preencherCombo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.preencherCombo();
  }

  private preencherCombo(){
    if (this.selecionado && this.dados.length) {
      if (typeof this.selecionado === 'string') {
        this.selecionado = _.find(this.dados, { tipo: this.selecionado});
      }
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }

}
